import { FileText, Megaphone, Rss } from "lucide-react";
import { useState } from "react";

type Tab = "noticias" | "comunicados";
type NewsItem = { title: string; date: string; tag: string };

const tagColors: Record<string, string> = {
  Patentes: "bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400",
  Marcas: "bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400",
  Internacional: "bg-violet-100 text-violet-700 dark:bg-violet-900/30 dark:text-violet-400",
  DI: "bg-teal-100 text-teal-700 dark:bg-teal-900/30 dark:text-teal-400",
  INPI: "bg-primary/10 text-primary",
  Monitoramento: "bg-rose-100 text-rose-700 dark:bg-rose-900/30 dark:text-rose-400",
  Sistema: "bg-muted text-slate-400",
  Interno: "bg-muted text-slate-400",
};

export function NewsSection({
  noticiasData,
  comunicadosData,
}: {
  noticiasData?: NewsItem[];
  comunicadosData?: NewsItem[];
}) {
  const [tab, setTab] = useState<Tab>("noticias");
  const items = tab === "noticias" ? (noticiasData || []) : (comunicadosData || []);

  return (
    <div className="h-full min-h-[260px] border bg-white p-4" style={{ borderRadius: 16, borderColor: 'rgba(226,235,240,0.5)', boxShadow: '0 1px 3px rgba(13,46,69,0.04), 0 4px 12px rgba(13,46,69,0.02)' }}>
      <div className="mb-3 flex items-center gap-2">
        <div className="flex gap-1">
          <button
            onClick={() => setTab("noticias")}
            className={`flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-[11px] font-medium transition-colors ${
              tab === "noticias" ? "bg-primary/10 text-primary" : "text-slate-400 hover:bg-muted"
            }`}
          >
            <FileText className="h-3 w-3" />
            Notícias
            {(noticiasData?.length || 0) > 0 && (
              <span className="ml-1 inline-flex h-4 min-w-[16px] items-center justify-center rounded-full bg-primary/20 px-1 text-[9px] font-bold text-primary">
                {noticiasData!.length}
              </span>
            )}
          </button>
          <button
            onClick={() => setTab("comunicados")}
            className={`flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-[11px] font-medium transition-colors ${
              tab === "comunicados" ? "bg-primary/10 text-primary" : "text-slate-400 hover:bg-muted"
            }`}
          >
            <Megaphone className="h-3 w-3" />
            Comunicados
            {(comunicadosData?.length || 0) > 0 && (
              <span className="ml-1 inline-flex h-4 min-w-[16px] items-center justify-center rounded-full bg-primary/20 px-1 text-[9px] font-bold text-primary">
                {comunicadosData!.length}
              </span>
            )}
          </button>
        </div>
      </div>

      {items.length === 0 ? (
        <div className="flex h-[calc(100%-2.75rem)] flex-col items-center justify-center text-center">
          <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-muted/60 mb-3">
            <Rss className="h-5 w-5 text-slate-400" />
          </div>
          <p className="text-[12px] font-medium text-slate-400">
            {tab === "noticias"
              ? "Nenhuma notícia recente da RPI"
              : "Nenhum comunicado recente"}
          </p>
          <p className="text-[10px] text-slate-400/70 mt-1">
            {tab === "noticias"
              ? "Alertas de processos do monitoramento RPI aparecerão aqui"
              : "Alertas de mercado e monitoramento aparecerão aqui"}
          </p>
        </div>
      ) : (
        <div className="space-y-2">
          {items.map((item, index) => (
            <div key={`${item.title}-${index}`} className="flex items-start gap-2 border-b border-slate-200/40 py-2 last:border-0 last:pb-0">
              <div className="min-w-0 flex-1">
                <p className="text-[12px] leading-relaxed text-slate-800/80">{item.title}</p>
                <div className="mt-1 flex items-center gap-2">
                  <span className="text-[10px] text-slate-400">{item.date}</span>
                  <span className={`rounded-full px-1.5 py-0.5 text-[9px] font-medium ${tagColors[item.tag] || "bg-muted text-slate-400"}`}>
                    {item.tag}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
